import { Injectable } from '@angular/core';

import { StockAdjustmentReason } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class StockAdjustmentReasonService extends TmsWebBaseEditService<StockAdjustmentReason, StockAdjustmentReason> {
  constructor() {
    super('StockAdjustmentReason', $localize`Stock Adjustment Reason`);
  }
}
